import translations from "../../translations/sheetFooter.json";
import { Translate, withLocalize } from "react-localize-redux";
import "../../styles/components/sheetFooter.scss";

function SheetFooter(props) {
	props.addTranslation(translations);

	return (
		<div
			id="sheet-footer"
			className={`flex-column ai-c ${
				props.isNewHeader ? "new-header-footer" : ""
			}`}
		>
			<div
				className="flex-row jc-sb"
				style={{ width: props.isNewHeader ? "100%" : "75%" }}
			>
				<a
					href={process.env.REACT_APP_TERMS_LINK}
					title="Verified Terms of Use"
					target="_blank"
				>
					<span className="link-text customizable-text">
						<Translate id="terms" />
					</span>
				</a>
				<a
					href={process.env.REACT_APP_PRIVACY_POLICY_LINK}
					title="Verified Privacy Policy"
					target="_blank"
				>
					<span className="link-text customizable-text">
						<Translate id="privacy" />
					</span>
				</a>
			</div>
		</div>
	);
}

export default withLocalize(SheetFooter);
